import { IconButton, Typography, SidePanel, Card } from "@/components/atoms";
import { useSelectedBooking } from "../../hooks/useSelectedBooking";
import { formatCurrency } from "@/utils";
import { isEmpty } from "ramda";

interface ExtrasAndFeesProps {
  open: boolean;
  onClose: () => void;
}

export const ExtrasAndFees = ({ open, onClose }: ExtrasAndFeesProps) => {
  const booking = useSelectedBooking();
  const { cost, extras, fees } = booking;

  return (
    <SidePanel open={open} onClose={onClose} width={550} focused>
      <section className="flex items-center justify-between p-5">
        <div className="flex items-center gap-2">
          <div className="h-[10px] w-[10px] rounded-full border border-neutral-dark-gray" />
          <Typography variant="title">Extras and Fees</Typography>
        </div>
        <div className="ml-3 flex h-7 items-center">
          <IconButton iconName="ArrowRight" onClick={onClose} className="-mr-2" variant="custom" />
        </div>
      </section>
      <section className="flex flex-col p-5 gap-y-2.5">
        <Card className="flex flex-col"> 
          <Typography variant="action">Extras</Typography>
          <div className="flex flex-col gap-y-1 mt-2">
            {(!extras || isEmpty(extras)) ? <Typography variant="paragraph">-</Typography> : extras.map((i, idx) => (
              <div key={idx} className="flex flex-row items-center justify-between w-full">
                <Typography variant="paragraph">{`• ${i.name}`}</Typography>
                <Typography variant="paragraph">{formatCurrency(i.cost, 2, cost.currency)}</Typography>
              </div>
            ))}
          </div>
        </Card>
        <Card className="flex flex-col"> 
          <Typography variant="action">Fees</Typography>
          <div className="flex flex-col gap-y-1 mt-2">
            {(!fees || isEmpty(fees)) ? <Typography variant="paragraph">-</Typography> : fees.map((i, idx) => (
              <div key={idx} className="flex flex-row items-center justify-between w-full">
                <Typography variant="paragraph">{`• ${i.name}`}</Typography>
                <Typography variant="paragraph">{formatCurrency(i.cost, 2, cost.currency)}</Typography>
              </div>
            ))}
          </div>
        </Card>
      </section>
    </SidePanel>
  );
};